import { useEffect } from "react";

/**
 * Custom hook to center toast notifications in the viewport
 * Injects CSS styles to override default toast positioning
 */
export const useToastStyles = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .ids-toaster-viewport {
        position: fixed !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
      }
      .ids-toast-container {
        position: relative !important;
      }
    `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);
};
